import React, { Fragment } from "react";
import Header from "../common/Header";
import { Link, useParams } from "react-router-dom";
import Footer from "../common/Footer";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const formattedDate = new Date().toLocaleDateString("en-US", {
  year: "numeric",
  month: "short",
  day: "2-digit"
});

const PaymentSuccess = ({amount, transaction_id, payment_id, payment_method, msg = '', cartData, countdown}) => {
    let { type } = useParams();

    return <Fragment>
        <Header type={type} />
         
        <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6">
            <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-8 text-center">
                <div className="flex justify-center mb-6">
                    <div className="bg-green-100 rounded-full p-4">
                        <CheckCircleIcon style={{ fontSize: 40, color: "#16a34a" }} />
                    </div>
                </div>

                <h1 className="text-2xl font-semibold text-green-600 mb-2">
                    Payment Successful!
                </h1>

                <div className="bg-gray-50 rounded-xl p-6 text-left space-y-4">
                
                    <div className="flex justify-between items-center border-b pb-4">
                        <span className="text-gray-500">Amount</span>
                        <span className="font-semibold text-lg">R {amount}</span>
                    </div>

                    <div className="flex justify-between items-center">
                        <span className="text-gray-500">Transaction ID</span>
                        <span className="bg-gray-200 px-3 py-1 rounded-md text-sm font-medium">
                            {transaction_id}
                        </span>
                    </div>

                    <div className="flex justify-between items-center">
                        <span className="text-gray-500">Payment ID</span>
                        <span className="bg-gray-200 px-3 py-1 rounded-md text-sm font-medium">
                            {payment_id}
                        </span>
                    </div>

                    <div className="flex justify-between items-center">
                        <span className="text-gray-500">Payment Method</span>
                        <span className="font-medium">{payment_method.toUpperCase()}</span>
                    </div>

                    <div className="flex justify-between items-center">
                        <span className="text-gray-500">Date</span>
                        <span className="font-medium">{formattedDate}</span>
                    </div>

                    {/* <div className="flex justify-between items-center">
                        <span className="text-gray-500">Tracking Reference</span>
                        <span className="bg-gray-200 px-3 py-1 rounded-md font-medium">{cartData?.data?.shipment?.custom_tracking_reference ?? '-'}</span>
                    </div> */}

                    <div className="flex justify-between items-center">
                        <Link to={'/pp'} className="w-full flex items-center justify-center gap-2 border border-gray-300 text-gray-700 font-medium py-3 rounded-md hover:bg-gray-200 active:scale-[0.99] transition">Create another shipment</Link>
                    </div>
                    <div className="flex justify-between items-center">
                       <span className="rounded-md text-sm">You will be redirected to home page after {countdown} seconds.</span>
                    </div>
                </div>

            </div>
        </div>
        <Footer/>
    </Fragment>
}

export default PaymentSuccess;